import type { JSX } from 'react';

import { CmsHtml } from 'src/app/shared/components/cms';

import { usePageBody } from './hooks/usePageBody';

export function PageBody(): JSX.Element {
	const {
		data: { html, styles },
	} = usePageBody();
	return <CmsHtml html={html} styles={styles} />;
}
